<div class="container">
    <h1 class="text-center" i18n>Resolver Consulta</h1>
    <div class="card p-4 mt-3" *ngIf="contact">
        <!-- Operator Selector -->
        <div class="mb-3" style="display: flex; justify-content: space-between; align-items: center;">
            <h4><span i18n>ID</span>: {{contact.identifier}}</h4>
            <h4 style="text-align: right;">{{contact.request.timestamp?.timestamp | date:'dd/MM/yyyy HH:mm'}}</h4>
        </div>

        <div class="mb-3">
            <label for="record" class="form-label"><strong i18n>Nº. Expediente:</strong></label>
            <input type="text" class="form-control" id="record" i18n-placeholder placeholder="Nº Expediente"
                [(ngModel)]="contact.request.record" disabled>
        </div>

        <div class="mb-3">
            <label for="email" class="form-label"><strong i18n>Email:</strong></label>
            <input type="email" class="form-control" id="email" disabled [(ngModel)]="contact.request.email">
        </div>

        <div class="mb-3">
            <label for="subject" class="form-label"><strong i18n>Asunto:</strong></label>
            <input type="text" class="form-control" id="subject" disabled [(ngModel)]="contact.request.subject">
        </div>

        <div class="mb-3">
            <label for="message" class="form-label"><strong i18n>Mensaje:</strong></label>
            <textarea class="form-control" id="message" rows="5" readonly disabled
                [(ngModel)]="contact.request.description"></textarea>
        </div>

        <div i18n>¿Por qué medio quiere ser comunicado?</div>
        <div class="mb-3">
            <div class="row">
                <div class="col-sm-12 col-md-6 mb-3">
                    <div class="row pt-2">
                        <div class="col-12">
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch" id="email-check" disabled
                                    [(ngModel)]="contact!.request.flagEmail">
                                <label class="form-check-label form-label" for="email-check" i18n>Recibir notificaciones por
                                    email</label>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch" id="sms" disabled
                                    [(ngModel)]="contact!.request.flagSms">
                                <label class="form-check-label form-label" for="sms" i18n>Recibir notificaciones por sms</label>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div class="col-sm-12 col-md-6 mb-3">
                    <label for="language"><span i18n>Idioma notificación</span><span class="required">*</span>: </label>
                    <select class="form-select form-label" id="language" disabled [(ngModel)]="contact!.request.flagLanguage">
                        <option value="" i18n>Selecciona Idioma</option>
                        <option value="ca-ES" i18n>Catalan</option>
                        <option value="es-ES" i18n>Español</option>
                        <option value="en-GB" i18n>Ingles</option>
                    </select>
                </div>
            </div>
        </div>

        <!-- Response Field -->
        <div class="mb-3">
            <label for="statusSelector" class="form-label"><strong i18n>Operador asignado:</strong></label>
            <select class="form-select no-arrow-select" id="statusSelector" [(ngModel)]="contact.operator" disabled>
                <option value=""></option>
                @for (operator of operators; track operator) {
                <option value="{{operator.identifier}}">{{operator.name}}</option>
                }
            </select>
        </div>

        <h5><span i18n>Tipo consulta</span>: {{translateType(contact.request.type)}}</h5>

        <h5><span i18n>Comentarios del operador</span></h5>

        <div>
            <label class="form-label">
                <span i18n>Comentarios del operador</span> {{getOperatorName(contact.response[0].operator)}} 
            </label>
            <textarea class="form-control mb-3" rows="5" [disabled]="contact.state == 'Closed'" [(ngModel)]="contact.response[0].comments"></textarea>
        </div>
        <div>
            <label class="form-label">
                <span i18n>Respuesta del operador</span> {{getOperatorName(contact.response[0].operator)}} 
                <span i18n>el dia</span> {{contact.response[0].timestamp?.timestamp | date:'dd/MM/yyyy'}} 
                <span i18n>a las</span> {{contact.response[0].timestamp?.timestamp | date:'HH:mm'}}
            </label>
            <textarea class="form-control mb-3" rows="5" [disabled]="contact.state == 'Closed'" [(ngModel)]="contact.response[0].officialResponse"></textarea>
        </div>
        <label class="form-label"><span i18n>Ficheros:</span></label>
        <div class="list-group">
            @for (file of contact.response[0].attachments; track file) {
            <div class="list-group-item d-flex justify-content-between align-items-center">
                <span>{{file.name}}</span>
                <button type="button" class="btn btn-outline-primary btn-icon" (click)="downloadFile(file)"
                    *ngIf="file.uuid"><i class="bi bi-download"></i></button>
            </div>
            }
            @if (contact.response[0].attachments.length == 0) {
            <div class="list-group-item d-flex justify-content-between align-items-center">
                <span i18n>No hay ficheros adjuntos</span>
            </div>
            }
        </div>


        <!-- File Upload -->
        <div class="mb-3 d-flex flex-column">
            <label for="fileUpload" class="form-label"><strong i18n>Adjuntar archivos</strong></label>
            <app-custom-input-file (onFileSelected)="onFileChange($event)" *ngIf="!resetFiles"></app-custom-input-file>
            <div class="mt-2">
                <div class="list-group">
                    @for (file of files; track file) {
                    <div class="list-group-item d-flex justify-content-between align-items-center">
                        <span>{{file.name}}</span>
                        <span class="badge bg-primary rounded-pill">{{ (file.size / 1024) | number: '1.0-2' }}
                            KB</span>
                    </div>
                    }
                </div>
            </div>
        </div>

        <div class="text-center mt-3">
            <!-- Submit Button -->
            <button class="btn btn-primary mr-5" (click)="save()" [disabled]="contact.state == 'Closed'" i18n>
                Guardar y continuar
            </button>
            <button class="btn btn-warning" (click)="close()" [disabled]="contact.state == 'Closed'" i18n>
                Cerrar y enviar
            </button>
        </div>
    </div>
</div>
<div class="text-center mt-3">
    <button class="btn btn-secondary" (click)="goBack()" i18n>Volver</button>
</div>